// HandshakeAnimation.js
import React from "react";
import Lottie from "react-lottie";
import handshakeAnimation from "./animations/handshake.json"; // Adjust the path as needed

const HandshakeAnimation = () => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: handshakeAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Lottie options={defaultOptions} height={400} width={400} />
    </div>
  );
};

export default HandshakeAnimation;
